<template>
  <div class="phone-index">
    <div class="title-box">
      <span class="text1">{{organizationName}}</span>
      <div class="right-btn">
        <i class="iconfont iconkefu"></i>
        <i class="iconfont iconxiaoxi"></i>
        <span class="num">22</span>
      </div>
    </div>
    <div class="empty-box">
      banner
      <div class="dian">
        <div class="dian1"></div>
        <div class="dian2"></div>
        <div class="dian3"></div>
      </div>
    </div>
    <draggable v-model="list" class="tools-list" :class="{ isOkBao: $units.isOkBao() || $units.isOkTX() }" @update="sortEvent" v-if="list.length" @drop.native.stop>
      <div class="tools-item" v-for="(bean,i) in list" :key="i">
        <img :src="bean.img" alt="">
        <span class="text">{{bean.name}}</span>
      </div>
    </draggable>
    <div class="empty-box" style="height:60px">头条</div>
    <div class="empty-box" style="height:280px">热销产品</div>
    <phoneNav active="index"></phoneNav>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import phoneNav from "./phoneNav";
export default {
  components: {
    draggable,
    phoneNav,
  },
  mixins:[],
  props: ["organizationName"],
  data() {
    return {
      list:[],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    setData(list){
      this.list = list.filter(item=>{
        return item.enable==1
      });;
    },
    sortEvent(){
      const ids = this.list.map(item=>{
        return item.id;
      })
      this.$http({
        url: "/buz/mcmMerchantModule/updateRank",
        type: "POST",
        data: {
          ids:ids.join(',')
        }
      }).then((res)=>{
        this.$emit("sort", this.list);
      })
    },
  },

};
</script>
<style lang="scss" scoped>
@import "./phoneIndex.scss";
</style>
